var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "q-field",
              { attrs: { count: 256 } },
              [
                _c("q-input", {
                  ref: "title",
                  attrs: {
                    "float-label": _vm.$t("title"),
                    error: _vm.$v.title.$error
                  },
                  on: { input: _vm.$v.title.$touch },
                  model: {
                    value: _vm.title,
                    callback: function($$v) {
                      _vm.title = $$v
                    },
                    expression: "title"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c(
              "p",
              {
                staticClass: "caption",
                class: _vm.$v.description.$error ? "text-negative" : ""
              },
              [
                _vm._v(
                  "\n\t\t\t\t" + _vm._s(_vm.$t("introduction")) + "\n\t\t\t"
                )
              ]
            ),
            _c("q-editor", {
              ref: "description",
              attrs: {
                error: _vm.$v.description.$error,
                toolbar: [
                  ["bold", "italic", "strike", "underline"],
                  ["left", "center", "right", "justify"],
                  ["link", "upload"],
                  [
                    {
                      label: null,
                      icon: "fas fa-font",
                      fixedLabel: true,
                      fixedIcon: true,
                      list: "no-icons",
                      options: ["p", "h1", "h2", "h3", "h4", "h5", "h6", "code"]
                    },
                    {
                      label: null,
                      icon: "fas fa-text-height",
                      fixedLabel: true,
                      fixedIcon: true,
                      list: "no-icons",
                      options: [
                        "size-1",
                        "size-2",
                        "size-3",
                        "size-4",
                        "size-5",
                        "size-6",
                        "size-7"
                      ]
                    },
                    "removeFormat"
                  ],
                  ["quote", "unordered", "ordered"]
                ],
                definitions: {
                  bold: { label: null, icon: "fas fa-bold" },
                  italic: { label: null, icon: "fas fa-italic" },
                  strike: { label: null, icon: "fas fa-strikethrough" },
                  underline: { label: null, icon: "fas fa-underline" },
                  left: { label: null, icon: "fas fa-align-left" },
                  center: { label: null, icon: "fas fa-align-center" },
                  right: { label: null, icon: "fas fa-align-right" },
                  justify: { label: null, icon: "fas fa-align-justify" },
                  link: { label: null, icon: "fas fa-link" },
                  removeFormat: { label: null, icon: "fas fa-eraser" },
                  quote: { label: null, icon: "fas fa-quote-right" },
                  unordered: { label: null, icon: "fas fa-list-ul" },
                  ordered: { label: null, icon: "fas fa-list-ol" }
                }
              },
              on: { input: _vm.$v.description.$touch },
              model: {
                value: _vm.description,
                callback: function($$v) {
                  _vm.description = $$v
                },
                expression: "description"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-select", {
              ref: "survey_type",
              attrs: {
                options: _vm.survey_types.map(function(s) {
                  return { label: this$1.$t(s.label), value: s.value }
                }),
                "float-label": _vm.$t("survey_type"),
                error: _vm.$v.survey_type.$error
              },
              on: { input: _vm.$v.survey_type.$touch },
              model: {
                value: _vm.survey_type,
                callback: function($$v) {
                  _vm.survey_type = $$v
                },
                expression: "survey_type"
              }
            })
          ],
          1
        ),
        _vm.selected_client_params.group_training_use_score
          ? _c(
              "div",
              { staticClass: "col-xs-12 col-sm-6" },
              [
                !_vm.selected_client_params.group_training_use_static_score
                  ? _c("q-input", {
                      ref: "score",
                      attrs: {
                        "float-label": _vm.$t("score"),
                        type: "number",
                        error: _vm.$v.score.$error
                      },
                      on: { input: _vm.$v.score.$touch },
                      model: {
                        value: _vm.score,
                        callback: function($$v) {
                          _vm.score = $$v
                        },
                        expression: "score"
                      }
                    })
                  : _vm._e(),
                _vm.selected_client_params.group_training_use_static_score
                  ? _c("q-select", {
                      ref: "score",
                      attrs: {
                        options: _vm.scores,
                        "float-label": _vm.$t("score"),
                        error: _vm.$v.score.$error
                      },
                      on: { input: _vm.$v.score.$touch },
                      model: {
                        value: _vm.score,
                        callback: function($$v) {
                          _vm.score = $$v
                        },
                        expression: "score"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              attrs: {
                type: "date",
                format: "DD/MM/YYYY",
                "float-label": _vm.$t("start_date"),
                clearable: ""
              },
              model: {
                value: _vm.start_date,
                callback: function($$v) {
                  _vm.start_date = $$v
                },
                expression: "start_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-6" },
          [
            _c("q-datetime", {
              attrs: {
                type: "date",
                format: "DD/MM/YYYY",
                "float-label": _vm.$t("end_date"),
                clearable: ""
              },
              model: {
                value: _vm.end_date,
                callback: function($$v) {
                  _vm.end_date = $$v
                },
                expression: "end_date"
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-12" },
          [
            _c("q-select", {
              ref: "tag",
              attrs: {
                options: _vm.optionTags,
                "float-label": _vm.$t("tags"),
                error: _vm.$v.tag.$error,
                multiple: "",
                chips: "",
                filter: "",
                "autofocus-filter": ""
              },
              on: { input: _vm.$v.tag.$touch },
              model: {
                value: _vm.tag,
                callback: function($$v) {
                  _vm.tag = $$v
                },
                expression: "tag"
              }
            })
          ],
          1
        )
      ]),
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1",
          attrs: { color: "secondary" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "permissions",
              icon: "fal fa-clipboard-list-check",
              label: _vm.$t("permissions")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-lg q-pb-xl", attrs: { name: "permissions" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c("p", { staticClass: "caption" }, [
                      _vm._v(_vm._s(_vm.$t("areas")))
                    ]),
                    _c("q-checkbox", {
                      staticClass: "q-mb-sm",
                      attrs: { val: true, label: _vm.$t("select_all_areas") },
                      on: {
                        input: function($event) {
                          return _vm.checkAllAreas()
                        }
                      },
                      model: {
                        value: _vm.all_areas,
                        callback: function($$v) {
                          _vm.all_areas = $$v
                        },
                        expression: "all_areas"
                      }
                    }),
                    _c("select-multiple", {
                      attrs: {
                        label: "",
                        filters: _vm.areas,
                        options: _vm.areas_list,
                        error: _vm.$v.areas.$error,
                        input: _vm.$v.areas.$touch
                      },
                      on: {
                        on_value: function($event) {
                          _vm.areas = $event
                        }
                      }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("profiles")))
                  ]),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-checkbox", {
                            attrs: { val: true, label: _vm.$t("all") },
                            on: {
                              input: function($event) {
                                return _vm.checkAll()
                              }
                            },
                            model: {
                              value: _vm.all_profiles,
                              callback: function($$v) {
                                _vm.all_profiles = $$v
                              },
                              expression: "all_profiles"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._l(_vm.profiles_list, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getErrorClass(_vm.$v.profiles.$error)
                          },
                          [
                            _c("q-checkbox", {
                              ref: "profiles",
                              refInFor: true,
                              attrs: {
                                "keep-color": "",
                                val: item.value,
                                label: item.label,
                                color: _vm.getErrorColor(_vm.$v.profiles.$error)
                              },
                              on: { input: _vm.$v.profiles.$touch },
                              model: {
                                value: _vm.profiles,
                                callback: function($$v) {
                                  _vm.profiles = $$v
                                },
                                expression: "profiles"
                              }
                            })
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c("q-select", {
                            ref: "user_groups",
                            attrs: {
                              options: _vm.user_groups_list,
                              "float-label": _vm.$t("groups"),
                              error: _vm.$v.user_groups.$error,
                              multiple: "",
                              chips: ""
                            },
                            on: { input: _vm.$v.user_groups.$touch },
                            model: {
                              value: _vm.user_groups,
                              callback: function($$v) {
                                _vm.user_groups = $$v
                              },
                              expression: "user_groups"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-11" },
                  [
                    _c("q-input", {
                      attrs: { "float-label": _vm.$t("link"), disable: true },
                      model: {
                        value: _vm.url_survey_portal,
                        callback: function($$v) {
                          _vm.url_survey_portal = $$v
                        },
                        expression: "url_survey_portal"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-1 q-mt-lg" },
                  [
                    _c(
                      "q-btn",
                      {
                        staticClass: "full-width",
                        attrs: {
                          dense: "",
                          color: "primary",
                          icon: "fal fa-copy"
                        },
                        on: {
                          click: function($event) {
                            return _vm.copyLink()
                          }
                        }
                      },
                      [
                        _c("q-tooltip", [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t" +
                              _vm._s(_vm.$t("copy_link")) +
                              "\n\t\t\t\t\t\t"
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ],
        1
      ),
      _c("div", { staticClass: "row gutter-sm q-mt-xs" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "q-chips-input",
              {
                attrs: { "float-label": _vm.$t("owners") },
                on: { remove: _vm.removeOwner },
                model: {
                  value: _vm.owners_list,
                  callback: function($$v) {
                    _vm.owners_list = $$v
                  },
                  expression: "owners_list"
                }
              },
              [
                _c("q-autocomplete", {
                  attrs: {
                    "min-characters": 3,
                    "value-field": function(v) {
                      return v.full_name + " - " + v.email
                    }
                  },
                  on: { search: _vm.searchOwner, selected: _vm.selectOwner }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "tertiary",
                label: _vm.$t("back"),
                icon: "far fa-chevron-left"
              },
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "admin_surveys" })
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("save"),
                icon: "far fa-save"
              },
              on: {
                click: function($event) {
                  return _vm.saveData()
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }